export var version = '3.6.10';
//# sourceMappingURL=version.js.map